import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'
import { Container } from '../components/Container'
import Header from '../components/Header'
import * as yup from 'yup'
import { formatuseFormErrors, log, sleep } from '../helpers/utils'
import ErrorAlert from '../components/Alerts/ErrorAlert'
import { API } from '../apis/API'
import { useRouter } from 'next/router'
import { UserStore } from '../state/UserStore'
import { useEffect, useRef, useState } from 'react'
import SuccessAlert from '../components/Alerts/SuccessAlert'
import Loader from '../components/Loader'
import { ShowField } from '../components/Product/ShowField'
import ReCAPTCHA from 'react-google-recaptcha'
import { GeneralAPI } from '../apis/GeneralAPI'
// import withoutAuthentication from '../hoc/withoutAuthentication'

const resetPassowordFields = [
    { name: 'code', label: 'Code', type: 'text', required: true },
    { name: 'email', label: 'Username', type: 'text', required: true },
    {
        name: 'new_password',
        label: 'New Password',
        type: 'password',
        required: true,
    },
]

const forgotPasswordFields = [
    { name: 'email', label: 'Email', type: 'email', required: true },
]

const rules = (code) => {
    let rulesObject = {}

    code
        ? resetPassowordFields.forEach(({ name, label }) => {
              rulesObject[name] = yup.string().required(`${label} is required.`)
          })
        : forgotPasswordFields.forEach(({ name, label }) => {
              rulesObject[name] = yup.string().required(`${label} is required.`)
          })

    return yup.object().shape(rulesObject)
}

export function ResetPassword({ data }) {
    const router = useRouter()
    const [code, setCode] = useState(null)
    const [fields, setFields] = useState([])

    const [success, setSuccess] = useState(null)

    const user = UserStore((state) => state.user)
    const [loading, setLoading] = useState(false)
    const [captchaToken, setCaptchaToken] = useState(null)
    const recaptchaRef = useRef()
    const onCaptchaChange = (value) => {
        setCaptchaToken(value || null)
        if (recaptchaRef.current) {
            recaptchaRef.current.value = value
        }
    }

    const {
        register,
        handleSubmit,
        setError,
        setValue,
        formState: { errors },
    } = useForm({ resolver: yupResolver(rules(code)) })

    const attemptForgotPassword = async (data) => {
        try {
            if (!captchaToken) {
                setError('custom', {
                    type: 'custom',
                    message: 'Please complete the reCAPTCHA.',
                })
                return
            }
            data.captcha = captchaToken
            await API.forgotPassword(data)
            setSuccess(
                'Reset password email has been sent. Please check your inbox.',
            )
        } catch (e) {
            log(e.response.data)
            const message =
                e?.response?.data?.message || 'Something went wrong.'
            setError('custom', { type: 'custom', message })
        }
    }

    const attemptResetPassword = async (data) => {
        try {
            if (!captchaToken) {
                setError('custom', {
                    type: 'custom',
                    message: 'Please complete the reCAPTCHA.',
                })
                return
            }
            data.captcha = captchaToken
            await API.resetPass(data)
            setSuccess(
                'You passoword has been reset. Redirecting you to login...',
            )
            sleep(3000).then(() => {
                router.push('/login')
            })
        } catch (e) {
            log(e.response.data)
            const message =
                e?.response?.data?.message || 'Something went wrong.'
            setError('custom', { type: 'custom', message })
        }
    }

    const handleForm = async (e) => {
        e.preventDefault()
        try {
            setLoading(true)
            code
                ? await handleSubmit(attemptResetPassword)()
                : await handleSubmit(attemptForgotPassword)()
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (user?.ID) router.push('/my-account')
    }, [user, router])

    useEffect(() => {
        if (router.query?.code) {
            setCode(router.query.code)
            setValue('code', router.query.code)
            setValue('email', router.query.login)
        }
        setFields(
            router.query?.code ? resetPassowordFields : forgotPasswordFields,
        )
    }, [router.query, setValue])

    return (
        <div>
            {loading && <Loader text="Working..." />}
            <Header title="Reset Password" meta={data?.yoast_head} />
            <Container>
                <div className="min-h-full flex justify-center ">
                    <div className="max-w-md w-full">
                        {success ? (
                            <SuccessAlert success={success} />
                        ) : (
                            <>
                                <div className="pb-8">
                                    <h2 className="mt-6 text-center text-3xl text-olm-black">
                                        {code
                                            ? 'Enter details'
                                            : 'Enter your email'}
                                    </h2>
                                </div>
                                <form
                                    onSubmit={handleForm}
                                    className=""
                                    method="POST">
                                    <div className="-space-y-px">
                                        {fields.map((item) => {
                                            return (
                                                <ShowField
                                                    key={item.name}
                                                    {...{
                                                        item,
                                                        register,
                                                        errors,
                                                    }}
                                                    shouldShowStrength={
                                                        router.query?.code
                                                    }
                                                    chrome-autofill="off"
                                                />
                                            )
                                        })}
                                    </div>
                                    <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:pt-5">
                                        <label className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                                            <span className="text-red-600">
                                                {' '}
                                            </span>
                                        </label>
                                        <div className="mt-1 sm:mt-0 sm:col-span-2">
                                            <ReCAPTCHA
                                                ref={recaptchaRef}
                                                sitekey={
                                                    process.env
                                                        .NEXT_PUBLIC_RECAPTCHA2_SITE_KEY
                                                }
                                                onChange={onCaptchaChange}
                                                onExpired={() =>
                                                    onCaptchaChange(null)
                                                }
                                                size="normal" // Can be "compact" or "invisible" if needed
                                                theme="light" // Can be "dark" if preferred
                                            />
                                        </div>
                                    </div>
                                    {Object.values(errors).length > 0 && (
                                        <ErrorAlert
                                            error={formatuseFormErrors(errors)}
                                            heading={
                                                'Please fix following error(s).'
                                            }
                                        />
                                    )}

                                    <div className="mt-6">
                                        <button
                                            type="submit"
                                            disabled={!captchaToken || loading}
                                            className={`group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white ${
                                                !captchaToken || loading
                                                    ? 'bg-gray-400 cursor-not-allowed opacity-60'
                                                    : 'bg-olm hover:bg-olh'
                                            } focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500`}>
                                            {code
                                                ? 'Reset Password'
                                                : 'Send Reset Email'}
                                        </button>
                                    </div>
                                </form>
                            </>
                        )}
                    </div>
                </div>
            </Container>
        </div>
    )
}

export default ResetPassword

//
export async function getStaticProps() {
    const page = await GeneralAPI.getPageBySlug('/reset-password')
    const data = page ? page[0] : {}
    return {
        props: { data: data },
        revalidate: 10, // In seconds
    }
}
